import type { ActionplanAttentionPoint } from "actionplan/types";

/**
 * Mirrors the `choices` options of the "Actionplan v3" template
 * (`database/migrations/2026_08_18_100000_create_actionplan_v3_template.php`,
 * plus "Lezen" from `2026_09_24_100000_add_lezen_attention_point_to_actionplan_v3.php`).
 * TODO: read these from the API once the student endpoints expose the template
 * questions.
 */
export const ACTIONPLAN_ATTENTION_POINTS: ActionplanAttentionPoint[] = [
  {
    id: "1",
    label: "Gedrag",
    tooltip:
      "Op tijd komen, luisteren naar de docent, luisteren naar elkaar, spullen in orde hebben.",
    optionOther: false,
  },
  {
    id: "2",
    label: "Motivatie",
    tooltip:
      "Hulp krijgen om gemotiveerd te blijven en door te zetten bij lastige zaken.",
    optionOther: false,
  },
  {
    id: "3",
    label: "Stress",
    tooltip:
      "Omgaan met spanning en druk, bijvoorbeeld rond toetsen, en leren hoe je weer tot rust komt.",
    optionOther: false,
  },
  {
    id: "4",
    label: "Samenwerken",
    tooltip:
      "Leren hoe je goed communiceert en samenwerkt met klasgenoten en leraren. Begrijpen dat mensen verschillend zijn.",
    optionOther: false,
  },
  {
    id: "5",
    label: "Leren",
    tooltip:
      "Overzicht creëren en houden, plannen en organiseren, efficiënt leren.",
    optionOther: false,
  },
  {
    id: "6",
    label: "Planning",
    tooltip:
      "Taken inplannen, balans tussen huiswerk en vrije tijd en op tijd komen.",
    optionOther: false,
  },
  {
    id: "7",
    label: "Concentratie",
    tooltip: "Focussen op de les, taak en huiswerk.",
    optionOther: false,
  },
  {
    id: "8",
    label: "Presenteren en schrijven",
    tooltip:
      "Leren presenteren, gedachten goed op papier zetten en verslagen schrijven, samenvatten.",
    optionOther: false,
  },
  {
    id: "9",
    label: "Reflecteren",
    tooltip:
      "Leren hoe je eerlijk naar jezelf kijkt, feedback gebruikt en je doelen aanpast op basis van wat je meemaakt.",
    optionOther: false,
  },
  {
    id: "11",
    label: "Lezen",
    tooltip:
      "Teksten goed lezen en begrijpen, de hoofdzaken eruit halen en je leesvaardigheid verbeteren.",
    optionOther: false,
  },
  {
    id: "10",
    label: "Anders, namelijk...",
    tooltip: null,
    optionOther: true,
  },
];
